export const open = () => {
  console.log('TODO open color picker')
}

export const close = () => {
  console.log('TODO close color picker')
}
